import React from 'react';
import bullet from '../../assets/home/club/bullet.svg';
import { useHomeData } from '../../hooks/useHomeData';

function HomeClub() {
    const { data } = useHomeData();
    const homeClubData = data?.club;

    if (!homeClubData?.title) {
        return <div className="loadingFiller"></div>;
    }

    return (
        <>
            <div id='homeClubWrapper'>
                <div className="homeClubContent">
                    <h2 className='homeClubTitle'><a href={homeClubData.button.href} target="_blank" rel="noreferrer">{homeClubData.title}</a></h2>
                    <p className='homeClubSubtitle'>{homeClubData.subtitle}</p>
                    <p className='homeClubDescription'>{homeClubData.description}</p>
                    
                    <ul className='homeClubList'>
                        <li className='homeClubListItem'>
                            <img src={bullet} alt="" width={12} height={14}/>
                            <span>{homeClubData.items[0]}</span>
                        </li>
                        <li className='homeClubListItem'>
                            <img src={bullet} alt="" width={12} height={14}/>
                            <span>{homeClubData.items[1]}</span>
                        </li>
                        <li className='homeClubListItem'>
                            <img src={bullet} alt="" width={12} height={14}/>
                            <span>{homeClubData.items[2]}</span>
                        </li>
                    </ul>
                    <p className='homeClubTagline'>{homeClubData.tagline}</p>
                    <a className='homeClubBtn' href={homeClubData.button.href} target="_blank" rel="noreferrer">{homeClubData.button.text}</a>
                    
                </div>
                
                <div className="homeClubImage">
                    <img src={homeClubData.image.path} alt={homeClubData.image.alt} loading='lazy' decoding='async' />
                </div>
            </div>
        </>
    );
}

export default HomeClub;
